// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file ping/ping_request.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

/**
 * Describes the file ping/ping_request.proto.
 */
export const file_ping_ping_request: GenFile =
  /*@__PURE__*/
  fileDesc(
    'ChdwaW5nL3BpbmdfcmVxdWVzdC5wcm90bxIUY29tLmdlbS5iZmYuY29udHJhY3QiDQoLUGluZ1JlcXVlc3RCGAoUY29tLmdlbS5iZmYuY29udHJhY3RQAWIGcHJvdG8z'
  );

/**
 * @generated from message com.gem.bff.contract.PingRequest
 */
export type PingRequest = Message<'com.gem.bff.contract.PingRequest'> & {};

/**
 * Describes the message com.gem.bff.contract.PingRequest.
 * Use `create(PingRequestSchema)` to create a new message.
 */
export const PingRequestSchema: GenMessage<PingRequest> =
  /*@__PURE__*/
  messageDesc(file_ping_ping_request, 0);
